import React from "react";
import { Link } from "react-router-dom";
import { useTimer } from "react-timer-hook";
import { useNavigate } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button, TextInput } from "ui";
import { notification } from "utils/notification";
import { useAppDispatch, useAppSelector } from "store";

import {
  setToken,
  setUserID,
  setUserState,
  setUserStateDetail,
} from "../../../layouts/dashboard-layout/slice";
import { otpFormFields, otpSchema } from "../../schema";
import { setId, setLoginState } from "../../slice";
import { useOtp } from "../../api/otp";
import { EXPIRY_TIME } from "../../constant";
import { useLogin } from "../../api/login";

export const VerifyOtpForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id, phoneNumber } = useAppSelector((state) => state.login);
  const { register, formState, handleSubmit } = useForm<otpFormFields>({
    resolver: zodResolver(otpSchema),
    defaultValues: {
      id: id,
      phoneNumber: phoneNumber,
    },
  });
  const { mutate, isLoading, error } = useOtp({});
  const loginQuery = useLogin({});
  const submitHandler: SubmitHandler<otpFormFields> = (
    values: otpFormFields
  ) => {
    mutate(
      {
        data: { ...values, id: Number(id) },
      },
      {
        onSuccess: ({ data }) => {
          dispatch(setUserState(data.data.status));
          dispatch(setUserStateDetail(data.data.statusDetail));
          dispatch(setUserID(data.data?.id));
          dispatch(setToken(data.data?.jwToken));
          if (data.data.status === "REGISTER") {
            navigate("/register");
          } else if (
            data.data.status === "AUTHENTICATION" ||
            data.data.status === "CREATEBUSINESS" ||
            data.data.status === "RECEIVE_IPG"
          ) {
            navigate("/authentication");
          } else {
            navigate("/dashboard");
          }
          dispatch(setLoginState("phone-number"));
        },
      }
    );
  };
  const { seconds, minutes, isRunning, restart } = useTimer({
    expiryTimestamp: EXPIRY_TIME(),
  });
  return (
    <form
      onSubmit={handleSubmit(submitHandler)}
      className="d-flex flex-column gap-3 w-100"
    >
      {error ? (
        <h1 className="text-danger">
          {error.response?.data.Message || error.message}
        </h1>
      ) : (
        <h1 className="text-success">کد تایید برای شما ارسال شد</h1>
      )}
      <TextInput
        label={
          <label className="d-flex gap-2">
            <span>شماره تلفن</span>
            <button
              type="button"
              onClick={() => dispatch(setLoginState("phone-number"))}
              className="button--striped link link-primary"
            >
              ( تغییر شماره تلفن )
            </button>
          </label>
        }
        disabled
        error={formState.errors.phoneNumber?.message}
        registration={register("phoneNumber")}
        placeholder={"شماره تلفن  خود را وارد کنید"}
      />
      <TextInput
        label={"کد تایید "}
        error={formState.errors.code?.message}
        registration={register("code")}
        placeholder={"کد تایید  خود را وارد کنید"}
      />
      <button
        type="button"
        className={`button--striped d-flex gap-2 ${!isRunning && "link"}`}
        disabled={isRunning}
        onClick={() => {
          loginQuery.mutate(
            {
              data: { phoneNumber: phoneNumber || "" },
            },
            {
              onSuccess: ({ data }) => {
                if (data.succeeded) {
                  notification(data.message, "success");
                  dispatch(setId(data.data.id));
                  restart(EXPIRY_TIME());
                } else {
                  notification(data.message, "error");
                }
              },
            }
          );
        }}
      >
        <span>ارسال مجدد</span>
        <span>{seconds}</span>
        <span>:</span>
        <span>{minutes}</span>
      </button>
      <Button
        isLoading={isLoading}
        isDisabled={isLoading}
        className="btn btn-primary w-100"
        type="submit"
        onClick={handleSubmit(submitHandler)}
      >
        ورود
      </Button>
    </form>
  );
};
